import styled from "styled-components";
import { Container, Store, Wrapper } from 'AppReact';
import { Image, InfoBox } from './molecules/atoms'
import { SolidButton } from './../../common/molecules'
import { GenericWrapper } from 'wrappers';

const template = styled.div`
  padding: 0 1rem;
`;

const Property = Container({
    template,
    name: "Property",
    props: { property: Store },
    elements: [
        {
            wrapper: GenericWrapper,
            name: "Section",
            elements: [
                {
                    component: Image,
                    name: 'PropertyImage',
                    displayValue: ({ property }) => property?.logo ?? '',
                },
                {
                    component: SolidButton,
                    name: 'ScheduleBtn',
                    displayValue: () => 'Schedule a Tour',
                    displayState: () => ({ big: true })
                },
                {
                    component: InfoBox,
                    name: 'InfoBox',
                    displayValue: ({ property }) => `Application Fee: $${property?.application_fee}.00`,
                },
                {
                    component: InfoBox,
                    name: 'FeePerApplicant',
                    displayValue: ({ property }) => `Application Fee: $${property?.additional_applicant_fee}.00 per additional applicant`,
                },
                {
                    component: InfoBox,
                    name: 'AdminFee',
                    displayValue: ({ property }) => `Admin Fee: $${property?.application_admin_fee}.00 per application`,
                },
            ]
        }
    ],
})

export default Property;
